export const benefits = [
    {
        icon: '○',
        title: 'Nessuna registrazione',
        text: 'Consulta le agenzie, confronta i servizi e leggi ogni dettaglio liberamente. Zero account, zero barriere.',
    },
    {
        icon: '□',
        title: 'Trasparenza totale',
        text: 'Consulta sedi, recapiti e informazioni delle agenzie. Contattale direttamente per disponibilità e preventivi personalizzati.',
    },
    {
        icon: '◇',
        title: 'Guida neutrale',
        text: 'Non spingiamo verso nessuna agenzia. Ti aiutiamo a capire le opzioni disponibili per decidere in piena autonomia.',
    },
    {
        icon: '◈',
        title: 'Agenzie selezionate',
        text: 'Ogni agenzia nella nostra rete è verificata per professionalità e affidabilità. Un supporto serio, sempre.',
    },
];

export const services = [
    {
        icon: '✦',
        title: 'Funerale tradizionale',
        text: 'Cerimonie curate in ogni dettaglio, nel rispetto delle tradizioni familiari e religiose, per un commiato dignitoso e raccolto.',
    },
    {
        icon: '✧',
        title: 'Cremazione',
        text: 'Accompagnamento completo nel percorso della cremazione, con la massima attenzione alla delicatezza del momento.',
    },
    {
        icon: '✦',
        title: 'Esequie laiche',
        text: 'Celebrazioni personalizzate per chi desidera un saluto intimo e autentico, libero da forme religiose ma ricco di significato.',
    },
    {
        icon: '✧',
        title: 'Trasporto salme',
        text: "Gestione del trasporto in Italia e all'estero, con tutte le pratiche documentali e doganali necessarie.",
    },
    {
        icon: '✦',
        title: 'Pratiche burocratiche',
        text: 'Molte delle agenzie selezionate gestiscono anche gli aspetti amministrativi: denuncia di morte, autorizzazioni, comunicazioni al Comune. Chiedi sempre in fase di preventivo cosa è incluso.',
    },
];

export const burialTypes = [
    {
        id: 'tumulazione',
        icon: '⊡',
        title: 'Tumulazione',
        tag: 'Sepoltura in loculo',
        text: "La salma viene collocata in un loculo o in una cappella di famiglia all'interno del cimitero. È la forma di sepoltura più comune in Italia.",
        detail: [
            'Il loculo può essere acquistato o concesso in uso per un periodo determinato (di solito 30–99 anni) dal Comune.',
            'Permette visite frequenti e la cura del posto della memoria con fiori e oggetti personali.',
            'Dopo un periodo variabile (solitamente 30–40 anni), la salma può essere estumulata e i resti trasferiti in ossario.',
            'Costo variabile a seconda del cimitero, della città e delle dimensioni del loculo scelto.',
        ],
    },
    {
        id: 'cremazione',
        icon: '⊙',
        title: 'Cremazione',
        tag: 'Riduzione in ceneri',
        text: 'Il corpo viene ridotto in ceneri attraverso un processo termico ad alta temperatura. Le ceneri possono poi essere conservate, disperse o tumulate.',
        detail: [
            "Richiede un'autorizzazione: volontà espressa dal defunto oppure dichiarazione del coniuge o dei parenti più prossimi aventi titolo.",
            "Le ceneri possono essere conservate nell'urna in casa, affidate a un familiare, tumulate in cimitero o disperse in natura (con autorizzazione comunale).",
            'È compatibile con qualsiasi tipo di cerimonia: religiosa, laica o civile.',
            'Generalmente meno costosa della tumulazione tradizionale, ma i costi variano in base al tipo di urna e alla destinazione delle ceneri.',
        ],
    },
    {
        id: 'inumazione',
        icon: '⊞',
        title: 'Inumazione',
        tag: 'Sepoltura in terra',
        text: "La salma viene sepolta direttamente nel terreno del cimitero, all'interno di una bara biodegradabile. È la forma più antica e naturale di sepoltura.",
        detail: [
            'La bara deve essere in materiale biodegradabile: legno, cartone rinforzato o altri materiali eco-compatibili approvati.',
            "Dopo 10 anni (tempo standard per la decomposizione) viene effettuata l'esumazione ordinaria. I resti vengono poi trasferiti in ossario comune o in un loculo.",
            'È la scelta con il minore impatto ambientale diretto, soprattutto se si utilizzano bare in materiale naturale.',
            'I costi sono generalmente più contenuti rispetto alla tumulazione in loculo.',
        ],
    },
];

export const guides = [
    {
        title: 'I primi giorni dopo la perdita',
        description: 'Cosa fare nelle prime 24–48 ore: a chi rivolgersi, cosa comunicare, come prendersi cura di sé e della famiglia.',
        detail: [
            "Contattare un'agenzia funebre entro le prime ore: si occuperà del trasporto della salma e dei primi adempimenti.",
            'Avvisare il medico di famiglia o il medico di guardia per il certificato di morte — documento indispensabile per tutto il resto.',
            'Comunicare il decesso ai familiari stretti e, quando possibile, al datore di lavoro per i permessi di legge (3 giorni retribuiti per lutto).',
            "Non è necessario far tutto da soli subito: l'agenzia guida passo dopo passo. Il primo giorno, è sufficiente occuparsi del necessario e lasciare che il resto attenda.",
        ],
    },
    {
        title: 'Come scegliere il rito più adatto',
        description: 'Funerale religioso, laico o cremazione: le differenze in modo chiaro per scegliere con consapevolezza.',
        detail: [
            "Funerale religioso: prevede una cerimonia in chiesa officiata da un sacerdote, con rito di suffragio. Richiede la disponibilità della parrocchia e può essere seguito da sepoltura o cremazione.",
            'Funerale laico: cerimonia personalizzata senza riferimenti religiosi. Si svolge in sala del commiato o in un luogo scelto dalla famiglia. Dà spazio a musica, letture e ricordi condivisi.',
            "Cremazione: può seguire qualsiasi tipo di cerimonia. Le ceneri possono essere conservate in un'urna, disperse (con autorizzazione) o tumulate. Richiede l'autorizzazione prevista dalla legge.",
            'Non esiste una scelta giusta in assoluto: conta ciò che rispecchia i valori del defunto e porta conforto a chi rimane.',
        ],
    },
    {
        title: 'Il lutto nei bambini',
        description: "Come parlare della morte ai più piccoli, quali segnali osservare e come supportarli nell'elaborazione.",
        detail: [
            "Usare parole chiare e dirette, adatte all'età: i bambini percepiscono quando qualcosa viene nascosto e l'incertezza li spaventa più della verità.",
            "Evitare eufemismi come 'se n'è andato' o 'sta dormendo': possono generare confusione o paure legate al sonno.",
            'Permettere ai bambini di partecipare al funerale se lo desiderano, spiegando in anticipo cosa accadrà. Escluderli può farli sentire tagliati fuori da un momento importante.',
            'Segnali da osservare: regressione comportamentale, difficoltà a scuola, disturbi del sonno, irritabilità. Se persistono oltre qualche settimana, può essere utile il supporto di uno psicologo infantile.',
        ],
    },
    {
        title: 'Pratiche burocratiche: guida completa',
        description: 'Dalla denuncia di morte al certificato di cremazione: i documenti necessari, passo dopo passo.',
        detail: [
            "Denuncia di morte: va presentata entro 24 ore al Comune di decesso. Di norma la effettua direttamente l'agenzia funebre.",
            "Atto di morte: rilasciato dall'Ufficio di Stato Civile. Necessario per pratiche bancarie, successioni, disdetta di contratti.",
            "Autorizzazione al seppellimento o alla cremazione: rilasciata dall'ufficiale dello stato civile del Comune. Richiede il certificato necroscopico del medico.",
            "Successione: entro 12 mesi dal decesso va presentata la dichiarazione di successione all'Agenzia delle Entrate se ci sono beni da trasferire. È consigliabile affidarsi a un CAF o a un notaio.",
        ],
    },
    {
        title: 'Vivere il lutto: risorse e supporto',
        description: 'Gruppi di ascolto, psicologi specializzati, associazioni: le risorse per non affrontare il dolore da soli.',
        detail: [
            'Il lutto non ha una durata standard: è normale attraversare fasi diverse — negazione, rabbia, tristezza, accettazione — in ordini diversi o più volte.',
            "Gruppi di auto-aiuto al lutto: presenti in molte città, spesso organizzati da parrocchie, associazioni laiche o ospedali. Condividere con chi ha vissuto la stessa esperienza può alleviare l'isolamento.",
            'Supporto psicologico individuale: uno psicologo specializzato in elaborazione del lutto può essere prezioso quando il dolore diventa paralizzante o prolungato. Alcune ASL offrono consulenze gratuite.',
            'Online: forum, comunità e risorse come Il Dono del Lutto o associazioni nazionali offrono materiali e contatti verificati.',
        ],
    },
    {
        title: 'Pianificare in anticipo',
        description: "Perché organizzare il proprio funerale in anticipo è un atto d'amore verso i propri cari.",
        detail: [
            "Pianificare in anticipo solleva i familiari dall'onere di prendere decisioni difficili in un momento di dolore acuto — è uno degli atti di cura più concreti che si possano fare.",
            'È possibile indicare le proprie volontà in un documento scritto: tipo di cerimonia, preferenza tra inumazione e cremazione, destinazione delle ceneri, musica o letture desiderate.',
            'Alcune agenzie offrono contratti pre-funerali: si versano i costi in anticipo (o a rate) bloccando il prezzo attuale. Verificare sempre che il contratto sia garantito da un fondo vincolato.',
            'La pianificazione anticipata non è un gesto morboso: è chiarezza, rispetto per chi rimane, e libertà di scegliere senza pressioni.',
        ],
    },
];

export const agencyBenefits = [
    {
        icon: '◈',
        title: 'Rete di agenzie verificate',
        text: 'Accedi a una rete selezionata di onoranze funebri certificate in tutta Italia. Ogni agenzia è valutata per qualità, affidabilità e trasparenza.',
    },
    {
        icon: '◈',
        title: 'Visibilità qualificata',
        text: 'Il tuo servizio visibile a chi sta cercando un funerale nella tua zona. Contatti pre-qualificati, non traffico generico.',
    },
    {
        icon: '◉',
        title: 'Supporto dedicato',
        text: 'Un referente Easy Funeral sempre disponibile per assistenza tecnica, commerciale e operativa. Non sei mai solo.',
    },
];
